import { Component, OnInit } from '@angular/core';
import { OrderService } from '../_services/order.service';
import { ToastrService } from 'ngx-toastr';
import { Ng2SearchPipe } from 'ng2-search-filter';
import { UserService } from '../_services/user.service';

@Component({
  selector: 'app-customer-review-rating',
  templateUrl: './customer-review-rating.component.html',
  styleUrls: ['./customer-review-rating.component.css']
})
export class CustomerReviewRatingComponent implements OnInit {
  allArtistDetails: any;
  allArtistDetailsfiltered: any;
  editProfileForm: any;
  editVoiceProfileForm: any;
  availabilityForm: any;
  equipmentExperienceForm: any;
  popup = false;
  loader: boolean = true;
  set searchParam(value:any){
    if(value != null && value !='')
    this.allArtistDetailsfiltered=Ng2SearchPipe.prototype.transform(this.allArtistDetails,value);
  else
  this.allArtistDetailsfiltered = this.allArtistDetails;

  this.page = 1
  this.NoOfTotReview = this.allArtistDetailsfiltered.length;
  }
  page: number = 1;
  NoOfTotReview: any;


  constructor(private userService: UserService,private orderService: OrderService) { }

  ngOnInit(): void {
    this.loader = false
    this.getAllVoicesample();
  }


  goToFirstPage() {
    this.page = 1; // Assuming 1-based indexing
}

goToLastPage() {
    // Calculate the last page based on the total number of items and items per page
    const totalPages = Math.ceil(this.allArtistDetailsfiltered.length / 10); // Assuming 45 items per page    
    this.page = totalPages;
}


acceptReviewAndRating(data: any) {
  this.orderService.acceptReviewAndRating(data.id, data.ratingComments).subscribe(data => {
    window.location.reload();
  },
    err => {
      console.log(err);
    });
}


isFirstPage(): boolean {
  return this.page != 1;
}

isLastPage(): any {        
  if(this.page == Math.ceil(this.allArtistDetailsfiltered.length / 10)){
    return false;
  } else {
    return true;
  }    
}

onPageChange(event: number): void {
  this.page = event;
}



getAllVoicesample() {
      this.orderService.customerReviewRatingList().subscribe(data => {
      this.allArtistDetails = data;
      this.allArtistDetailsfiltered = data;     
      this.NoOfTotReview =  this.allArtistDetails.length;
      this.allArtistDetails.forEach((element: {}) => {
      });
    },
      err => {
        console.log(err);
      }
    );
  }

  


}